<template>
  <div data-testid="checks-secion-panel" class="tw-flex tw-flex-col tw-gap-4">
    <sf-assistant-check
      v-for="checkId in groupedCheckIds?.[workflowId]?.[contextId]"
      :key="checkId"
      :check="checksById[checkId]"
      :read="checkReadStatus[checkId]"
    />
    <slot name="after-checks" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import SfAssistantCheck from '@app/application/sf-assistant-checks/components/sf-assistant-check.vue'

import { useSfAssistantChecksPage } from '../stores/page'

interface Props {
  workflowId: string
  contextId: string
}

defineProps<Props>()

const sfAssistantChecksPageStore = useSfAssistantChecksPage()

const { checkReadStatus, groupedCheckIds, checksById } = storeToRefs(
  sfAssistantChecksPageStore
)
</script>
